import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14 4.26309L10.4303 0.449598L10.4303 7.91592L14 4.26309Z",
      fill: "#7F7466"
    }, null, -1),
    _createElementVNode("path", {
      d: "M-1.54809e-07 8.72645L3.56975 12.5399L3.56975 5.07362L-1.54809e-07 8.72645Z",
      fill: "#7F7466"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3.08272 8.84969L6.65942 8.84969C6.84983 8.84969 7.00425 8.68821 7.00425 8.4891L7.00425 4.49933C7.00425 4.30022 7.15867 4.13874 7.34908 4.13874L11.0979 4.13874",
      stroke: "#7F7466",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }